import { render, staticRenderFns } from "./ResellerProductViewGallery.vue?vue&type=template&id=2928e8e7"
import script from "./ResellerProductViewGallery.vue?vue&type=script&lang=js"
export * from "./ResellerProductViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports